export default class ValetHelper {

    // Si les donnée sdu valet sont ok pour être validées
    static isValetDataOk(valetData) {
        return valetData.gmap_status == 'OK';
    }
}